import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'vectronic-synced-data-filter',
  templateUrl: './synced-data-filter.component.html',
  styleUrls: ['./synced-data-filter.component.scss'],
  imports: [CommonModule, MatIconModule, MatSlideToggleModule, MatTooltipModule],
})
export class SyncedDataFilterComponent implements OnInit {
  filtersForm = input<FormGroup>();
  title = input<string>();

  onlyLocalData = false;
  destroyRef = inject(DestroyRef);
  ngOnInit() {
    this.onlyLocalData = this.filtersForm().get('onlyLocalData').value;

    this.filtersForm()
      .get('onlyLocalData')
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        if (value === null) this.onlyLocalData = false;
      });
  }

  toggle() {
    this.onlyLocalData = !this.onlyLocalData;
    this.filtersForm().get('onlyLocalData').setValue(this.onlyLocalData);
  }
}
